import { CartState } from '../types';
import appStore from '../utils/state';

export default class CartCheckout extends HTMLElement {
  private totalPrice: HTMLParagraphElement | null = null;
  private checkoutButtonLabel: HTMLSpanElement | null = null;

  private checkoutButtonLabelTemplate: string = '';

  private unsubscribeFromCartUpdating: (() => void) | null = null;
  private unsubscribeFromCartUpdated: (() => void) | null = null;

  private onCartUpdatingBound = this.onCartUpdating.bind(this);
  private onCartUpdatedBound = this.onCartUpdated.bind(this);

  connectedCallback(): void {
    this.totalPrice = this.querySelector('[data-cart-checkout-ref="total-price"]');
    this.checkoutButtonLabel = this.querySelector('[data-cart-checkout-ref="checkout-button-label"]');

    this.checkoutButtonLabelTemplate = this.dataset.checkoutButtonLabelTemplate ?? '';

    this.addEventListeners();
    this.subscribe();
  }

  addEventListeners(): void {}

  removeEventListeners(): void {}

  subscribe(): void {
    this.unsubscribeFromCartUpdating = appStore.subscribeKey('cartIsUpdating', this.onCartUpdatingBound);
    this.unsubscribeFromCartUpdated = appStore.subscribeKey('cart', this.onCartUpdatedBound);
  }

  unsubscribe(): void {
    if (this.unsubscribeFromCartUpdating) {
      this.unsubscribeFromCartUpdating();
      this.unsubscribeFromCartUpdating = null;
    }
    if (this.unsubscribeFromCartUpdated) {
      this.unsubscribeFromCartUpdated();
      this.unsubscribeFromCartUpdated = null;
    }
  }

  onCartUpdating(isUpdating: boolean): void {
    this.setCheckoutLoading(isUpdating);
  }

  onCartUpdated(cart: CartState): void {
    if (this.totalPrice && cart.data?.total_price) {
      this.totalPrice.textContent = cart.data.total_price;
    }

    if (this.checkoutButtonLabel && cart.data?.total_price) {
      this.checkoutButtonLabel.textContent = this.checkoutButtonLabelTemplate.replace(
        '[total_price]',
        cart.data.total_price,
      );
    }

    this.setCheckoutLoading(false);
  }

  private setCheckoutLoading(isLoading: boolean): void {
    this.totalPrice?.classList.toggle('shimmer-text', isLoading);
    this.checkoutButtonLabel?.classList.toggle('shimmer-text-dark', isLoading);
  }

  disconnectedCallback(): void {
    this.removeEventListeners();
    this.unsubscribe();
  }
}

customElements.define('cart-checkout', CartCheckout);
